module.exports = __webpack_public_path__ + "img/174020diamond-resorts-international.05d43674.jpg";